exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.json-editor .label-item {\n  height: 40px;\n  line-height: 40px;\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.json-editor .label-item.common {\n  max-width: 90%;\n}\n.json-editor .label-text {\n  font-size: 14px;\n  color: #333;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-weight: 700;\n}\n.json-editor .label-icon {\n  font-size: 14px;\n  cursor: pointer;\n  transition: 0.3s;\n  color: #666;\n  position: absolute;\n  top: 2px;\n  right: -10px;\n}\n.json-editor .label-icon:hover {\n  color: #20a0ff;\n}\n.json-editor .editor-block {\n  height: 200px;\n  position: relative;\n}\n.json-editor .editor-block .el-alert--warning {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 200px;\n  height: 35px;\n  z-index: 99;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d8f5a47","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/compEditForm/jsonEditor.vue
// module id = 1140
// module chunks = 7